// Consent-gated Google Analytics 4. The gtag script is only injected after
// the visitor accepts cookies; declining keeps the site completely tag-free.
export const GA_MEASUREMENT_ID =
  process.env.GATSBY_GA_MEASUREMENT_ID || "G-6MRK687D81"

export type ConsentValue = "granted" | "denied"

const CONSENT_KEY = "tf-cookie-consent"
export const CONSENT_SETTINGS_EVENT = "tf-open-cookie-settings"

declare global {
  interface Window {
    dataLayer?: any[]
  }
}

export function getStoredConsent(): ConsentValue | null {
  if (typeof window === "undefined") return null
  try {
    const value = window.localStorage.getItem(CONSENT_KEY)
    return value === "granted" || value === "denied" ? value : null
  } catch {
    return null
  }
}

export function storeConsent(value: ConsentValue): void {
  try {
    window.localStorage.setItem(CONSENT_KEY, value)
  } catch {
    // private mode without storage - consent simply won't persist
  }
}

let gtagLoaded = false

export function loadGoogleAnalytics(): void {
  if (typeof window === "undefined" || gtagLoaded) return
  gtagLoaded = true

  window.dataLayer = window.dataLayer || []
  window.gtag = function gtag() {
    // gtag requires the Arguments object itself, not a spread copy
    window.dataLayer!.push(arguments)
  }

  window.gtag("consent", "default", {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: "denied",
  })
  window.gtag("consent", "update", { analytics_storage: "granted" })
  window.gtag("js", new Date())
  window.gtag("config", GA_MEASUREMENT_ID, {
    anonymize_ip: true,
    send_page_view: false,
  })

  const script = document.createElement("script")
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`
  document.head.appendChild(script)
}

export function revokeAnalyticsConsent(): void {
  if (typeof window === "undefined" || !window.gtag) return
  window.gtag("consent", "update", { analytics_storage: "denied" })
}

export function trackPageView(path: string): void {
  if (typeof window === "undefined") return
  if (getStoredConsent() !== "granted" || !window.gtag) return
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  })
}
